import { INewOwner, IOwner, IPersonOwner, UUID } from "src/app/core/interfaces";

export namespace Owner {
  export class GetAll {
    static readonly type = "[Owner] Get All";
  }
  export class GetAllSuccess {
    static readonly type = "[Owner] Get All Success";
    constructor(public owners: IOwner[]) {}
  }
  export class GetAllFail {
    static readonly type = "[Owner] Get All Fail";
    constructor(public error: unknown) {}
  }

  export class GetById {
    static readonly type = "[Owner] Get By Id";
    constructor(public ownerId: UUID) {}
  }
  export class GetByIdSuccess {
    static readonly type = "[Owner] Get By Id Success";
    constructor(public owner: IOwner) {}
  }
  export class GetByIdFail {
    static readonly type = "[Owner] Get By Id Fail";
    constructor(public error: unknown) {}
  }

  export class GetByEntityId {
    static readonly type = "[Owner] Get By Entity Id";
    constructor(public entityId: UUID, public orgId?: UUID) {}
  }
  export class GetByEntityIdSuccess {
    static readonly type = "[Owner] Get By Entity Id Success";
    constructor(public owners: IOwner[]) {}
  }
  export class GetByEntityIdFail {
    static readonly type = "[Owner] Get By Entity Id Fail";
    constructor(public error: unknown) {}
  }

  export class Create {
    static readonly type = "[Owner] Create";
    constructor(public owner: INewOwner<IOwner>) {}
  }
  export class CreateSuccess {
    static readonly type = "[Owner] Create Success";
    constructor(public owner: IOwner) {}
  }
  export class CreateFail {
    static readonly type = "[Owner] Create Fail";
    constructor(public error: unknown) {}
  }

  export class Update {
    static readonly type = "[Owner] Update";
    constructor(public owner: IOwner) {}
  }
  export class UpdateSuccess {
    static readonly type = "[Owner] Update Success";
    constructor(public updatedOwner: IOwner) {}
  }
  export class UpdateFail {
    static readonly type = "[Owner] Update Fail";
    constructor(public error: unknown) {}
  }

  export class DeleteSuccess {
    static readonly type = "[Owner] Delete Success";
    constructor(public ownerId: UUID) {}
  }

  export class AddEntity {
    static readonly type = "[Owner] Add Entity";
    constructor(
      public ownerId: UUID,
      public entityId: UUID,
      public orgId?: UUID,
    ) {}
  }

  export class RemoveEntity {
    static readonly type = "[Owner] Remove Entity";
    constructor(
      public ownerId: UUID,
      public entityId: UUID,
      public orgId: UUID | null,
    ) {}
  }

  export class RemoveOrgEntities {
    static readonly type = "[Owner] Remove Org Entities";
    constructor(
      public ownerId: UUID,
      public orgId: UUID,
    ) {}
  }

  export class RemoveEntityFromOwners {
    static readonly type = "[Owner] Remove Entity From Owners";
    constructor(
      public ownerIds: UUID[],
      public entityId: UUID,
      public orgId: UUID | null,
    ) {}
  }

  export class RemoveEntityFromOwnersSuccess {
    static readonly type = "[Owner] Remove Entity From Owners Success";
    constructor(
      public updatedOwnersMap: {[ownerId: UUID]: IOwner | null},
    ) {}
  }

  export class RemoveEntityFromOwnersFail {
    static readonly type = "[Owner] Remove Entity From Owners Fail";
    constructor(
      public error: unknown,
    ) {}
  }

  export class SendAutoCollectEmail {
    static readonly type = "[Owner] Send Auto Collect Email";
    constructor(
      public owner: IPersonOwner,
      public entityId?: UUID,
      public legalName?: string,
    ) {}
  }

  export class SendMultipleAutoCollectEmails {
    static readonly type = "[Owner] Send Multiple Auto Collect Emails";
    constructor(
      public ownerIds: UUID[],
      public orgId: UUID,
      public entityName?: string,
    ) {}
  }

  export class SendMultipleAutoCollectEmailsSuccess {
    static readonly type = "[Owner] Send Multiple Auto Collect Emails Success";
    constructor(
      public owners: IOwner[],
    ) {}
  }

  export class SendMultipleAutoCollectEmailsFail {
    static readonly type = "[Owner] Send Multiple Auto Collect Emails Fail";
    constructor(
      public error: unknown,
    ) {}
  }

  export class UploadGovIdImage {
    static readonly type = "[Owner] Upload GovId Image";
    constructor(
      public image: string,
      public mediaType: string,
      public ownerId: UUID
    ) {}
  }

  export class ReplaceGovIdImage {
    static readonly type = "[Owner] Replace GovId Image";
    constructor(
      public image: string,
      public mediaType: string,
      public ownerId: UUID,
      public docUrl: string | null,
    ) {}
  }

  export class DeleteGovIdImage {
    static readonly type = "[Owner] Delete GovId Image";
    constructor(public ownerId: UUID, public docUrl: string | null) {}
  }

  export class ManageGovIdImageSuccess {
    static readonly type = "[Owner] Manage GovId Image Success";
    constructor(public updatedOwner: IOwner) {}
  }

  export class ManageGovIdImageFail {
    static readonly type = "[Owner] Manage GovId Image Fail";
    constructor(public error: unknown) {}
  }
}
